export class LocalStorageHelper {

  static getCourseNotation(
    restoId: number,
    svcId: number,
    courseId: number
  ) : number|undefined{
    const key = `course_${restoId}_${svcId}_${courseId}`;
    const item: string|null = localStorage.getItem(key);

    if(item === null)return undefined;

    return parseInt(item);
  }

  static noteCourse(
    restoId: number,
    svcId: number,
    courseId: number,
    stars: number
  ){
    const key = `course_${restoId}_${svcId}_${courseId}`;
    localStorage.setItem(key, stars.toString());
  }

  static getCourseCommentAndMail(
    restoId: number,
    svcId: number,
    courseId: number
  ): {email: string, comment: string}|undefined{
    const key = `comment_${restoId}_${svcId}_${courseId}`;
    const item: string|null = localStorage.getItem(key);

    if(item === null)return undefined;

    const [email, comment] = item.split(";");
    return {email, comment};
  }

  static commentCourse(
    restoId: number,
    svcId: number,
    courseId: number,
    email: string,
    comment: string
  ){
    const key = `comment_${restoId}_${svcId}_${courseId}`;
    localStorage.setItem(key, `${email};${comment}`);
  }

  static order_getCourseNotation(
    restoId: number,
    svcId: number,
    courseId: number,
    orderId: number
  ) : number|undefined{
    const key = `order_course_${restoId}_${svcId}_${courseId}_${orderId}`;
    
    const item: string|null = localStorage.getItem(key);

    if(item === null)return undefined;

    return parseInt(item);
  }

  static order_noteCourse(
    restoId: number,
    svcId: number,
    courseId: number,
    stars: number,
    orderId: number
  ){
    const key = `order_course_${restoId}_${svcId}_${courseId}_${orderId}`;
    localStorage.setItem(key, stars.toString());
  }

  static order_getCourseCommentAndMail(
    restoId: number,
    svcId: number,
    courseId: number,
    orderId: number
  ): string|undefined{
    const key = `order_comment_${restoId}_${svcId}_${courseId}_${orderId}`;
    const item: string|null = localStorage.getItem(key);

    if(item === null)return undefined;

    return item;
  }

  static order_commentCourse(
    restoId: number,
    svcId: number,
    courseId: number,
    comment: string,
    orderId: number
  ){
    const key = `order_comment_${restoId}_${svcId}_${courseId}_${orderId}`;
    localStorage.setItem(key, `${comment}`);
  }


  static order_hasAnyData(orderId: number){
    for(let i = 0; i < localStorage.length; i++){
      const key = localStorage.key(i);
      if(key === null)continue;
      if(!key.startsWith("order"))continue;

      if(key.includes(orderId.toString())){
        return true;
      }
    }

    return false;
  }
}
